<div class="table-responsive">
  <table mat-table [dataSource]="dataSource" class="mat-elevation-z1 w-100">
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef i18n>Name</th>
      <td mat-cell *matCellDef="let element">{{ element.title }}</td>
    </ng-container>
    <ng-container matColumnDef="email">
      <th mat-header-cell *matHeaderCellDef i18n>Email</th>
      <td mat-cell *matCellDef="let element">{{ element.primaryemail }}</td>
    </ng-container>
    <ng-container matColumnDef="created">
      <th mat-header-cell *matHeaderCellDef i18n>Created</th>
      <td mat-cell *matCellDef="let element">{{ element.created | epoch }}</td>
    </ng-container>
    <ng-container matColumnDef="lastmessage">
      <th mat-header-cell *matHeaderCellDef i18n>Last Message</th>
      <td mat-cell *matCellDef="let element">{{ element.lastmessage | epoch }}</td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns" (click)="onEdit(row)" class="clickable"></tr>
  </table>

  <mat-paginator2
    #paginator
    [length]="dataSource?.data?.length"
    [pageSize]="10"
    [pageSizeOptions]="[5, 10, 20, 50, 75, 100]"
    [showFirstLastButtons]="true"
  >
  </mat-paginator2>
</div>
